import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import "rxjs/add/operator/toPromise";

const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" })
};

@Injectable()
export class ApiService {
  url = "https://verkerkselect.solucionesalrespecto.com/admin/public/api/";
  // url = "https://admin.hoyaiselect.com/api/";

  constructor(private http: HttpClient) {}

  cretateLifeStyle(questionnaire): Promise<any> {
    return this.http
      .post(this.url + "lifestyle", questionnaire)
      .toPromise()
      .then(response => console.log(response));
  }
}



// WEBPACK FOOTER //
// ./src/app/api.service.ts